import React, { Component, Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import withRouter from 'components/components/common/withRouter';
import {
  setAddressInReservationEdit,
  setCustomerAddresses
} from 'components/actions/serviceActions';
import MapPlaces from 'components/components/common/MapPlaces';

class ReservationEditMap extends Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <MapPlaces
        busStops={this.props.busStops}
        customerAddresses={this.props.customerAddresses}
        setCustomerAddresses={this.props.setCustomerAddresses}
        setChosenAddress={this.props.setAddressInReservationEdit}
        locale={this.props.locale}
        editReservationMode
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerAddresses: state.service.customerAddresses,
    busStops: state.service.busStops,
    locale: state.app.locale
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    {setAddressInReservationEdit, setCustomerAddresses}
  )(ReservationEditMap)
);
